import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id } = payload || {}
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_UPDATE_WITHDRAWAL_STATUS, {
      pathParams: {
        withdrawalId: id,
      },
    })
  },

  method: 'PATCH',

  format(payload) {
    const { status, reason } = payload || {}
    return {
      status,
      reason
    }
  },

  parse(raw = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to update withdrawal status',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Statut du retrait mis à jour',
      data: raw.data,
    }
  },
}
